
interface GridExchangeProps {
  data: any;
}

export function GridExchange({ data }: GridExchangeProps) {
  if (!data) return null;

  const isPositiveBalance = data.balance > 0;

  return (
    <div className={`bg-gradient-to-br ${isPositiveBalance ? 'from-green-50 to-green-100' : 'from-red-50 to-red-100'} rounded-xl shadow-sm p-6 border-2 ${isPositiveBalance ? 'border-green-200' : 'border-red-200'} hover:shadow-lg transition-all duration-300`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`bg-gradient-to-br ${isPositiveBalance ? 'from-green-500 to-green-600' : 'from-red-500 to-red-600'} w-12 h-12 rounded-lg flex items-center justify-center shadow-lg`}>
          <i className={`${isPositiveBalance ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-white w-6 h-6 flex items-center justify-center text-2xl`}></i>
        </div>
        <div className="text-right">
          <div className={`text-xs ${isPositiveBalance ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100'} font-semibold px-2 py-1 rounded-full`}>
            {isPositiveBalance ? 'VENDIENDO' : 'COMPRANDO'}
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Intercambio con Red
      </h3>

      <div className="space-y-3">
        <div>
          <div className="flex items-baseline space-x-1 mb-1">
            <span className={`text-3xl font-bold ${isPositiveBalance ? 'text-green-700' : 'text-red-700'}`}>
              {Math.abs(data.balance).toFixed(1)}
            </span>
            <span className={`text-sm font-semibold ${isPositiveBalance ? 'text-green-600' : 'text-red-600'}`}>kWh</span>
          </div>
          <p className="text-xs text-gray-600">
            Balance neto {isPositiveBalance ? 'exportado' : 'importado'}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
          <div>
            <div className="text-lg font-bold text-red-700">
              {data.imported.toFixed(1)}
            </div>
            <p className="text-xs text-gray-600">Importado</p>
            <p className="text-xs text-red-600 font-medium">€{data.cost.toFixed(2)}</p>
          </div>
          
          <div>
            <div className="text-lg font-bold text-green-700">
              {data.exported.toFixed(1)}
            </div>
            <p className="text-xs text-gray-600">Exportado</p>
            <p className="text-xs text-green-600 font-medium">€{data.revenue.toFixed(2)}</p>
          </div>
        </div>
      </div>

      {/* Balance económico */}
      <div className="mt-4 p-3 bg-white/70 rounded-lg">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-700">Balance económico:</span>
          <span className={`text-sm font-bold ${(data.revenue - data.cost) >= 0 ? 'text-green-700' : 'text-red-700'}`}>
            €{(data.revenue - data.cost).toFixed(2)}
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
          <div 
            className={`${(data.revenue - data.cost) >= 0 ? 'bg-green-500' : 'bg-red-500'} h-2 rounded-full transition-all duration-500`}
            style={{ width: `${Math.min(100, Math.abs((data.revenue - data.cost) / 5) * 100)}%` }}
          ></div>
        </div>
      </div>

      <div className="mt-4 flex items-center space-x-2">
        <div className={`w-2 h-2 ${isPositiveBalance ? 'bg-green-500' : 'bg-red-500'} rounded-full animate-pulse`}></div>
        <span className="text-xs text-gray-600 font-medium">Intercambio activo</span>
      </div>
    </div>
  );
}
